/**
 * ARR roll-up for the Client → Billing tiles.
 *
 * A commercial position can be reduced two ways, and the tiles used to
 * see only one of them:
 *
 *   1. `discount_pct` on a positive line -> surfaces as `annual_discount`
 *   2. a NEGATIVE-priced credit line (e.g. "Courtesy Discount"
 *      -GBP2,991.60/yr) -> a first-class commercial line whose annual
 *      value is simply negative
 *
 * The old roll-up summed every line into gross and only counted (1) as a
 * discount, so a client whose credit is modelled as (2) displayed
 * Gross == Net and Discounts == 0.00 — the credit vanished from the
 * screen while still being correctly applied in the total. GR Carr
 * showed 31,658.40 / 0.00 / 31,658.40 when the truth is
 * 34,650.00 / -2,991.60 / 31,658.40.
 *
 * Partition by sign, matching `compute_spec_totals` on the backend, so
 * the tile and the specification can never disagree.
 *
 * `creditTotal` is SIGNED (negative reduces the position), so the
 * invariant is simply: grossArr + creditTotal === annualTotal.
 */
export function rollUpArr(activeItems) {
  let grossArr = 0, creditTotal = 0, annualTotal = 0;
  for (const i of activeItems || []) {
    const net = Number(i.annual_amount) || 0;
    const gross = i.annual_amount_gross != null ? Number(i.annual_amount_gross) : net;
    annualTotal += net;
    if (net < 0) {
      creditTotal += net;                              // signed credit line
    } else {
      grossArr += gross;                               // pre-discount value
      creditTotal -= Number(i.annual_discount) || 0;   // percentage discount
    }
  }
  const r2 = (n) => Math.round(n * 100) / 100;
  return { grossArr: r2(grossArr), creditTotal: r2(creditTotal), annualTotal: r2(annualTotal) };
}

export default rollUpArr;
